export const API_BASE_URL = 'https://your-api-url.com/'
export const API_DOMAIN = process.env.REACT_APP_DEV_API_URL